var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBulbIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1393_21233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4285 9.14289C18.4364 7.99541 18.1371 6.86672 17.5615 5.874C16.9859 4.88128 16.1551 4.06072 15.1553 3.49751C14.1556 2.93429 13.0232 2.64896 11.8759 2.67112C10.7286 2.69328 9.60819 3.02214 8.63091 3.62355C7.65362 4.22495 6.85513 5.07699 6.31832 6.0912C5.78151 7.1054 5.52596 8.24481 5.5782 9.39113C5.63043 10.5375 5.98855 11.6489 6.61538 12.6101C7.2422 13.5713 8.11488 14.3471 9.14281 14.8572V17C9.14281 17.1895 9.21806 17.3712 9.35202 17.5051C9.48597 17.6391 9.66765 17.7143 9.8571 17.7143H14.1428C14.3323 17.7143 14.5139 17.6391 14.6479 17.5051C14.7818 17.3712 14.8571 17.1895 14.8571 17V14.8572C15.9249 14.3311 16.8249 13.5176 17.4558 12.5081C18.0867 11.4987 18.4235 10.3333 18.4285 9.14289V9.14289Z",
    stroke: "#312F2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.14307 21.2856H14.8574",
    stroke: "#312F2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1393_21233"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulbIcon);
export default __webpack_public_path__ + "static/media/BulbIcon.eeb7bf4c0f6e7878898e2758d3da8d29.svg";
export { ForwardRef as ReactComponent };